import React, { useState, useEffect } from 'react';
import photo1 from '../../../Assets/Home/ktech_home_pic_1.png'
import photo2 from '../../../Assets/Home/ktech_home_pic_2.png'
import { Link } from 'react-router-dom';


const ExploreKapil = () => {
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

 
  const leftTranslation = Math.min(scrollPosition * 0.05, 50); 
  const rightTranslation = Math.max(scrollPosition * -0.1, -50); 

  return (
    <div>
     
       <div className="relative w-full min-h-screen bg-pink-50 p-8 bg-[#fdf5e2 ]">
      <div className="max-w-[1400px] mx-auto relative ">
        {/* Section Header */}
        <div className=" mb-12">
          <h2 className="text-md ml-10 font-bold" style={{ color: "#691883" }}>
            Explore Kapil
          </h2>
          <p className="mt-4 text-xl max-w-2xl ml-10 text-gray-700">
            Discover our leadership and <span style={{ color: "#F15A29" }}>career opportunities.</span>  
          </p>
        </div>

        {/* Cards Container */}
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-16 md:gap-28">
          {/* Left Card - Careers */}
          <div 
            className="w-full md:w-[400px] group cursor-pointer transition-all duration-300"
            style={{ transform: `translateX(${leftTranslation}px)` }}
          >
            <div className="bg-[#511264] hover:bg-[c] h-[620px] w-full shadow-lg rounded-lg overflow-hidden">
              <div className="mb-6 bg-[#cb54f0]">
                <img 
                  src={photo1} 
                  alt="Our Team" 
                  className="w-full "
                />
              </div>
              <div className="space-y-4">
                <h2 className="text-3xl p-8 font-light text-[white] group-hover:text-[#cb54f0]">
                  Join a Team of Changemakers
                </h2>
                <button className="flex items-center font-semibold p-6 text-lg text-[white] group-hover:text-[#cb54f0]">
                  <span> <Link to="/career">Careers at Kapil</Link></span>
                  <svg 
                    className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={2} 
                      d="M17 8l4 4m0 0l-4 4m4-4H3" 
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          {/* Right Card - Company About */}
          <div 
            className="w-full md:w-[400px] group cursor-pointer transition-all duration-300 md:mt-16"
            style={{ transform: `translateX(${rightTranslation}px)` }}
          >
            <div className="bg-[#F15A29] hover:bg-[#ffaf7a] h-[540px] w-full shadow-lg rounded-lg overflow-hidden">
              <div className="space-y-4 mb-6">
                <h2 className="text-4xl p-8 font-light text-[white] group-hover:text-[#F15A29]">
               Building a Better Tomorrow
                </h2>
                <button className="flex p-6 items-center text-lg text-[white] group-hover:text-[#F15A29]">
                  <span> <Link to="/insights/aboutus">About Kapil</Link></span>
                  <svg 
                    className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={2} 
                      d="M17 8l4 4m0 0l-4 4m4-4H3" 
                    />
                  </svg>
                </button>
              </div>
              <div>
                <img 
                  src={photo2} 
                  alt="Company Manager" 
                  className="w-full mt-24 object-cover"
                />
                  
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
   </div>
  );
};

export default ExploreKapil;
